export enum ContractDetails {
    PRICES = 'prices',
    CONTRACT_CONCEPTS = 'contractConcepts',
    CLOSURES = 'closures',
}
